import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_user = (id, userName, passWord, NickName) => {
  return api.post(`${ApiEndpointConstants.MODIFYUSER}`, {
    id,
    userName,
    passWord,
    NickName,
  });
};
